export const environment = {
  production: false,
  api_key: '2B9009D2-D048-43BA-A2EB-EAF07C6D3A8D',
  coApiUrl: 'https://cmcloudcoapi-dev.azurewebsites.net/api/',
  stack: 'dev10-co.clinicmaster.com',
};
